import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable, of } from 'rxjs';
import { ContactsCompaniesPageComponent } from '../contacts-companies.page/contacts-companies.page';
import { ContactsAddCompanyComponent } from 'src/app/components/contacts-add-company/contacts-add-company.component';
import { ContactService } from 'src/app/services/contact.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AppGlobals } from 'src/app/app.globals';
import { HasChanges } from 'src/app/services/guards/unsaved-changes.guard';

@Component({
    selector: 'app-contacts-add-company.page',
    templateUrl: './contacts-add-company.page.html',
    styleUrls: ['./contacts-add-company.page.css'],
    providers: [ContactsAddCompanyComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, ContactsAddCompanyComponent]
})
export class ContactsAddCompanyPageComponent implements HasChanges {

  // The routed component is this thin wrapper, not the reusable form — canDeactivate
  // checks this class, so the guard's HasChanges contract is fulfilled by delegating
  // straight through to the form component's own state (see hasChangesGuard).
  @ViewChild(ContactsAddCompanyComponent) addCompanyForm: ContactsAddCompanyComponent;

  get hasChanges(): boolean {
    return this.addCompanyForm?.hasChanges ?? false;
  }
  set hasChanges(value: boolean) {
    if (this.addCompanyForm) this.addCompanyForm.hasChanges = value;
  }

  get isSavingChanges(): boolean {
    return this.addCompanyForm?.isSavingChanges ?? false;
  }
  set isSavingChanges(value: boolean) {
    if (this.addCompanyForm) this.addCompanyForm.isSavingChanges = value;
  }

  constructor(private contactService: ContactService, private router: Router, private appGlobals: AppGlobals) {
/*     if (environment.isTestEnvironment === true) { */
      this.appGlobals.SetGlobalMenuIndex(6);
/*     } else {
      this.appGlobals.SetGlobalMenuIndex(4);
    } */
  }

  checkHasChanges(): void {
    this.addCompanyForm?.checkHasChanges();
  }

  saveUnsavedChanges(): Observable<boolean> {
    return this.addCompanyForm?.saveUnsavedChanges() ?? of(true);
  }

  handleAbort(e) {
    this.router.navigate([e.returnTo]);
  }

  handleSubmit(e) {
    this.router.navigate([e.returnTo])
  }
}
